const MENU_OPEN  = 'MENU_OPEN';
const MENU_CLOSE = 'MENU_CLOSE';

class Header {
  constructor() {
    // Root
    this._root = document.querySelector('.site-header');

    // Elements
    this._burger = this._root.querySelector('.site-header__burger');

    // Attributes
    this._status = MENU_CLOSE;

    // Events
    this._onBurger = this.toggle.bind(this);
    this._burger.addEventListener('click', this._onBurger);
  }

  toggle() {
    if (this._status === MENU_OPEN) {
      return this._status = this.close();
    }
    return this._status = this.open();
  }

  open() {
    document.documentElement.classList.add('is-menu-open');
    document.documentElement.classList.add('lock-scroll');

    return MENU_OPEN;
  }

  close() {
    document.documentElement.classList.remove('is-menu-open');
    document.documentElement.classList.remove('lock-scroll');

    return MENU_CLOSE;
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/js/layouts/chrome/header.js